import type { DashboardResponseDto, GetConfigResponseDto } from '@zg-rentals/ts-rent-payment-client';

import type { RenterConfigInterface, RenterStatusNumericInputInterface } from '@renter-hub/models/Types';

export const mapDashboardResponseToRenterStatusInput = (
  dashboardResponse: DashboardResponseDto,
): RenterStatusNumericInputInterface =>
  ({
    ...dashboardResponse,
    enableCreditTracking: dashboardResponse.enableCreditTracking ?? false,
  }) as unknown as RenterStatusNumericInputInterface;

export const mapGetConfigResponseToConfig = (configResponse: GetConfigResponseDto): RenterConfigInterface => ({
  stripePublicKey: configResponse.stripePublicKey ?? '',
  plaidEnv: configResponse.plaidEnv ?? '',
  enablePaymentStatus: configResponse.enablePaymentStatus ?? false,
});
